export default __webpack_public_path__ + "static/media/dataIntegrityAnalysis.8ab3c838.svg";